import { connect } from "react-redux";
import { formatTimeHM } from "../../../services/helpers/Helper";

const PhonePreview = (props) => {
   const { children, page } = props;

   return (
      <div className="preview-container">
         <div className="preview-container__screen">
            <div className="preview-status-bar">
               <div className="preview-status-bar__time">
                  <span>
                     {formatTimeHM()}
                  </span>
               </div>
               <div className="preview-status-bar__energy">
                  <div className="svg-next-icon ic-phone-status">
                  </div>
               </div>
               <div className="preview-status-bar__white-block"></div>
            </div>
            <div className="preview-store-info">
               <div className="preview-store-info__arrow-image">
                  <div className="svg-next-icon ic_back">
                  </div>
               </div>
               <div className="preview-store-info__avatar">
                  <span content={page.name} className="app-avatar app-avatar-circle app-avatar-image" style={{ width: 26, height: 26, lineHeight: '26px', background: 'rgb(41, 121, 255)' }}>
                     <img src={page.page_avatar} />
                  </span>
               </div>
               <div className="preview-store-info__name text-ellipsis">
                  <span>
                     {page.name}
                  </span>
               </div>
            </div>
            <div className="preview-container__body">
               {children}
            </div>
            <div className="preview-footer">
               <div className="preview-footer__menu">
                  <div className="preview-footer__menu-item-1">
                     <div className="svg-next-icon ic-plus-circle-2" style={{ backgroundColor: 'rgb(0, 132, 255)' }}>
                     </div>
                  </div>
                  <div className="preview-footer__menu-item-2">
                     <div className="svg-next-icon ic-input-preview-message">
                     </div>
                  </div>
                  <div className="preview-footer__menu-item-3">
                     <div className="svg-next-icon next-icon-menu">
                     </div>
                  </div>
               </div>
               <div className="preview-footer__bottom-bar">
                  <div></div>
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { page } = state;
   return {
      page
   };
};

export default connect(mapStateToProps, {})(PhonePreview);